import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentProfile, setLoggedInUser } from "../../redux/action";
import Leftside from "../Landing_page/Left_sidebar/Leftside";
import styles from "./profile.module.css";
import GitHubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import PublicIcon from '@material-ui/icons/Public';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
// import ControlPointIcon from '@material-ui/icons/ControlPoint';
// import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { ProfileSmallComp } from "./ProfileSmallComp";
import { PostComp } from "./PostComp";
import CreateOutlined from "@material-ui/icons/CreateOutlined";
import { v4 as uuid } from 'uuid';
import { Spinner } from "./Spinner";



const Container = styled.div`
width: 79%;
display: flex;
flex-direction: column;
min-height: 600px;
background-color: rgb(245,247,250);
`;
const DetailsDiv = styled.div`
background-color: white;
border-radius: 7px;
border:1px solid #ebeef1;
/* border:1px solid #06233f; */
height: 560px;
`;
const Post = styled.div`
cursor: pointer;
padding: 8px;
width: 96%;
min-height: 300px;
background-color: white;
border: 1px solid #eaeff8;
display: flex;
flex-direction: column;
margin: 5px 0px;
border-radius: 8px;
`;
const SubDiv = styled.div`
background-color: rgb(245,247,250);
display: flex;
padding: 0;
min-height: 410px;
`;
const Followers = styled.div`
width: 60%;
display: flex;
flex-wrap: wrap;
/* border:1px solid red; */
/* background-color: white; */
div {
    text-align: center;
}
`;
const Following = styled.div`
width: 60%;
display: flex;
flex-wrap: wrap;
align-items: flex-start;
min-height: 400px;

div {
    text-align: center;
}
/* border:1px solid red; */
/* background-color: white; */
`;
const ActivityDiv = styled.div`
background-color: rgb(245,247,250);
display: flex;
flex-direction: column;
width: 65%;
/* border: 1px solid green; */
margin:15px 0px;
border-radius: 8px;
/* border:1px solid #ebeef1; */

/* padding: 15px 5px; */
/* div {
    background-color: white;
    border-radius: 10px;
    min-height: 300px;
    width: 100%;
} */
`;
const InfoDiv = styled.div`
width: 37%;
background-color: rgb(245,247,250);
display: flex;
flex-direction: column;
margin-right: 22px;
/* border:1px solid red; */
div {
    background-color: white;
    border-radius: 8px;
    margin-top: 15px;
    width: 100%;
    /* border:1px solid green */
}
`;

const Bio = styled.div`

min-height: 100px;
display: flex;
background-color: white;
border:1px solid #ebeef1;
flex-direction: column;
padding-left: 5px;
padding-top: 8px;
max-width: 99%;
`;
const Stats = styled.div`
display: flex;
border:1px solid #ebeef1;
padding: 0;
padding-bottom: 5px;
/* border:1px solid yellow */
`;
const TechStack = styled.div`
min-height: 250px;
border:1px solid #ebeef1;
`;
const ImgDiv = styled.div`
height: 61%;
img {
    height: 100%;
    width: 100%;
}
`;
const ProfDets = styled.div`
height: 19%;
div {
    display: flex;
}
p {
    text-align: center;
}

`;
const Nav = styled.div`
margin: 29px;
padding: 5px;
display: flex;
`;
const Tabs = styled.div`
display: flex;
justify-content: space-evenly;
width: 41%;
margin: auto;
margin-bottom:5px;
margin-top: 12px;
padding: 11.5px;
`;
const ProfileSmall = styled.div`
padding: 5px;
background-color: white;
width: 210px;
height: 290px;
border-radius: 8px;
margin:15px;
`;
const ProfilePicDiv = styled.div`
width: 39%;
height: 30%;
border-radius: 51%;
background-color: #c5bebe;
margin:15px auto;
box-shadow: 3px 3px 3px grey;
img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
`;
const ProfileImageDiv = styled.img`
background-color: white;
position: absolute;
/* left: 28.8%; */
/* bottom: 40.1%; */
width: 150px;
height: 150px;
border-radius: 75px;
left: 470.31px;
top: 255.8px;
/* box-shadow: 3px 3px 3px grey; */
/* padding: 10px; */
/* background-color: green; */
`;

export const Profile = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const profilePicRef = useRef();
    const [followingList, setFollowingList] = useState([])
    const [followersList, setFollowersList] = useState([])
    const [recentActivity, setRecentActivity] = useState([]);
    const [joined, setJoined] = useState("October");
    const [owner, setOwner] = useState(false);
    const [profile, setProfile] = useState(true)
    const [following, setFollowing] = useState(false)
    const [followers, setFollowers] = useState(false)
    const [posts, setPosts] = useState([]);
    const [changed, setChanged] = useState(false);
    const [isFollowing, setIsFollowing] = useState();
    const token = useSelector(state => state.token);
    const currentProfile = useSelector(state => state.currentProfile);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const url = process.env.REACT_APP_url;

    
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${url}/users/${username}`)
            .then((data) => {
                // console.log(data.data.user);
                dispatch(setCurrentProfile(data.data.user));
            })
            .catch((err) => {
                alert(err);
                // console.log("err", err);
            })
            .finally(() => {
                setIsLoading(false);
            })
    if (loggedIn) {
            setIsLoading(true);
            axios.get(`${url}/users/${loggedInUser.username}`)
                .then((data) => {
                    // console.log(data.data.user);
                    dispatch(setLoggedInUser(data.data.user));
                })
                .catch((err) => {
                    alert(err)
                    // console.log("err", err);
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }
        // axios.get(`${url}/comments/user/${currentProfile._id}`)
        //     .then((res) => {
        //         console.log("comments by the user", res.data.comments);
        //         setRecentActivity(res.data.comments);
        //     })
        //     .catch((err) => {
        //         alert(err);
        //     })
    }, []);
    useEffect(() => {
        load();
    }, [changed, currentProfile, loggedInUser])

    const load = () => {
        if (loggedInUser?.following?.includes(currentProfile._id)) {
            // console.log(loggedInUser, currentProfile);
            setIsFollowing(true);
        } else {
            setIsFollowing(false);
        }
        if (loggedInUser.username == currentProfile.username) {
            setOwner(true);
        } else {
            setOwner(false);
        }
        axios.get(`${url}/users/${currentProfile.username}/following`)
            .then((res) => {
                // console.log("following");
                setFollowingList(res?.data?.following?.following);
            })
            .catch((err) => {
                alert(err);
            })
        axios.get(`${url}/users/${currentProfile.username}/followers`)
            .then((res) => {
                // console.log("followers", res.data.followers);
                setFollowersList(res.data.followers);
            })
            .catch((err) => {
                alert(err);
            })
        // setIsLoading(true);
        axios.get(`${url}/posts/users/${currentProfile.username}`)
            .then((res) => {
                // console.log(res.data.posts);
                setPosts(res.data.posts);
            })
            .catch((err) => {
                alert(err);
            })
            // .finally(() => {
            //     setIsLoading(false);
            // })
        axios.get(`${url}/comments/user/${currentProfile._id}`)
            .then((res) => {
                // console.log("comments by the user", res.data.comments);
                setRecentActivity(res.data.comments);
            })
            .catch((err) => {
                alert(err);
            })
    } 
    useEffect(() => {
        
        let joined = currentProfile?.createdAt?.slice(0, 10).split("-").reverse();
        let month;
        switch (joined[1]) {
            case "01": month = "January";
                break;
            case "02": month= "February";
                break;
            case "03": month = "March";
                break;
            case "04": month= "April";
                break;
            case "05": month = "May";
                break;
            case "06": month= "June";
                break;
            case "07": month = "July";
                break;
            case "08": month= "August";
                break;
            case "09": month = "September";
                break;
            case "10": month= "October";
                break;
            case "11": month = "November";
                break;
            case "12": month= "December";
                break;
            default: month = "October";
                break;
        }
        let str = `${joined[0]} ${month}, ${joined[2]}`;
        setJoined(str);
        // console.log(joined);
    }, [currentProfile])
    const { username } = useParams();
    // console.log(username);
    const getDate = (val) => {
        let joined = val.slice(0, 10).split("-").reverse();
        let month;
        switch (joined[1]) {
            case "01": month = "January";
                break;
            case "02": month= "February";
                break;
            case "03": month = "March";
                break;
            case "04": month= "April";
                break;
            case "05": month = "May";
                break;
            case "06": month= "June";
                break;
            case "07": month = "July";
                break;
            case "08": month= "August";
                break;
            case "09": month = "Sep";
                break;
            case "10": month= "Oct";
                break;
            case "11": month = "November";
                break;
            case "12": month= "December";
                break;
            default: month = "October";
                break;
        }
        let str = `${month} ${joined[0]}, ${joined[2]}`;
        return str;
    }
    const handleFollow = () => {
        if (!loggedIn) {
            history.push("/login");
        } else {
            setIsFollowing(true);
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            // const bodyParameters = {
            //     key: "value"
            // };
            axios.patch( 
                `${url}/users/follow/${username}`,{}, config)
                .then((data) => {
                    // console.log(data)
                    setChanged(!changed);
                })
                .catch((err) => {
                    alert(err);
                    // console.log(err);
                })
        }
    }
    const handleUnfollow = () => {
        setIsFollowing(false);
        const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            // const bodyParameters = {
            //     key: "value"
            // };
            axios.patch( 
                `${url}/users/unfollow/${username}`,{}, config)
                .then((data) => {
                    // console.log(data)
                    setChanged(!changed);
                })
                .catch((err) => {
                    alert(err)
                    // console.log(err);
                })
    }
    const showProfile = () => {
        setProfile(true); setFollowing(false); setFollowers(false);
        
    }
    const showFollowing = () => {
        setFollowing(true); setProfile(false); setFollowers(false);

    }
    const showFollowers = () => {
        setFollowers(true); setProfile(false); setFollowing(false);

    }
    const addBookmark = (postid) => {
        axios.patch(`${url}/users/addbookmark/${loggedInUser._id}/post/${postid}`)
            .then((res) => {
                console.log(res.data.user);
            })
            .catch((err) => {
                alert(err);
            })
    }
    
    
    return (
        <div style={{backgroundColor:"rgb(245,247,250)"}}>
            {isLoading ? <Spinner/> : (
                <div style={{ display: "flex", backgroundColor: "rgb(245,247,250)", justifyContent: "space-between" }}>
                    <Leftside />
                    <div style={{ minWidth: "230px" }}></div>
                    <Container>
                        <DetailsDiv>
                            <ImgDiv>
                                <img src={currentProfile.cover_pic} alt="cover" />
                        
                                {/* <img src="https://cdn.hashnode.com/res/hashnode/image/upload/v1584035951809/rA6njTVVd.jpeg?w=1600&fit=crop&crop=entropy&auto=compress&auto=compress" alt="cover"/> */}
                            </ImgDiv>
                            <ProfDets>
                                <div style={{ width: "157px", height: "157px", borderRadius: "85px", backgroundColor: "white", position: "absolute", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", left: "467.08px", top: "252.5px" }}></div>
                                <ProfileImageDiv src={currentProfile.profile_pic} alt="profile">
                                    {/* <img /> */}
                                </ProfileImageDiv>
                                <p className={styles.nameDiv}>{currentProfile?.name}</p>
                                <p className={styles.tagline}>{currentProfile?.tagline}</p>
                                {owner ? <div className={styles.editDiv} onClick={() => history.push("/settings")}>
                                    <CreateOutlined style={{ color: "#636161", marginRight: "5px" }} />
                                    <div>Edit Profile</div>
                                </div> : null}
                                {!owner ? <div style={{ width: "30%", margin: "29px auto", marginTop: "23px" }}>
                                    {!isFollowing ? <button className={styles.btn} onClick={handleFollow}>
                                        {/* <ControlPointIcon fontSize="small" style={{margin:"0px 5px", color:"#5985fd"}}/> */}
                                        Follow
                                    </button> : <button className={styles.btnSpl} onClick={handleUnfollow}>Following</button>}
                                    <button style={{ display: "flex", alignItems: "center" }} className={styles.btn}>
                                        <ArrowDropDownIcon fontSize="large" style={{ marginRight: "3px" }} />
                                        More
                                    </button>
                                </div> : null}
                            </ProfDets>
                            <Nav>
                                <Tabs>
                                    <div style={{ padding: "10px 25px", cursor: "pointer", fontSize: "13.5px", fontWeight: "600", color: "#292828", borderBottom: profile ? "2.1px solid rgb(41,98,255)" : null }} onClick={showProfile}>
                                        PROFILE
                                    </div>
                                    <div style={{ padding: "10px 25px", cursor: "pointer", fontSize: "13.5px", fontWeight: "600", color: "rgb(12,12,12)", borderBottom: followers ? "2.1px solid rgb(41,98,255)" : null }} onClick={showFollowers}>
                                        FOLLOWERS
                                    </div>
                                    <div style={{ padding: "10px 25px", cursor: "pointer", fontSize: "13.5px", fontWeight: "600", color: "rgb(12,12,12)", borderBottom: following ? "2.1px solid rgb(41,98,255)" : null }} onClick={showFollowing}>
                                        FOLLOWING
                                    </div>
                                </Tabs>
                            </Nav>
                        </DetailsDiv>
                        <SubDiv>
                            <InfoDiv>
                                <Bio>
                                    {/* <div className={styles.profTagDiv}>
                                {loggedInUser.tagline}
                            </div> */}
                                    <p className={styles.joined}>Joined: {joined}</p>
                                    <div className={styles.social}>
                                        <GitHubIcon fontSize="large" className={styles.icons} />
                                        <TwitterIcon fontSize="large" className={styles.icons} />
                                        <PublicIcon fontSize="large" className={styles.icons} />
                                    </div>
                                </Bio>
                                <Stats>
                                    <div className={styles.statsDiv} style={{ display: "flex" }}>
                                        <div style={{ display: "flex", margin: "0", flexDirection: "column", alignItems: "start" }}>
                                            <p style={{ marginLeft: "19px" }}>Followers</p>
                                            <div style={{ marginLeft: "19px", width: "70%" }}>{followersList.length}</div>
                                        </div>
                                        <div style={{ display: "flex", margin: "0", flexDirection: "column" }}>
                                            <p style={{ marginLeft: "19px" }}>Following</p>
                                            <div style={{ marginLeft: "19px", width: "70%" }}>{followingList.length}</div>
                                        </div>
                                    </div>
                                </Stats>
                                <TechStack>
                                    {recentActivity.map((item) => (
                                        <div key={uuid()} style={{ display: "flex", margin: "1px", borderBottom: "0.5px solid #f1f7fc", alignItems: "center" }}>
                                            <BorderColorTwoToneIcon style={{ padding: "8px 15px", color: "rgb(33,150,243)" }} />
                                            <div style={{ margin: "5px", padding: "5px", width: "80%", cursor: "pointer" }} onClick={() => history.push(`/posts/${item?.post?._id}`)}>
                                                <div style={{ color: "grey", margin: "0", padding: "3px 0px", paddingTop: "0px", width: "80%", fontSize: "16px" }}>Commented</div>
                                                <div style={{ fontWeight: "700", margin: "0", padding: "0", color: "#413e3e" }}>{item.post?.title}</div>
                                                <div style={{ margin: "10px 0px", padding: "0", color: "grey", fontSize: "13px" }}>{getDate(item.createdAt)}</div>
                                            </div>
                                        </div>
                                    ))}
                                </TechStack>
                            </InfoDiv>
                            {profile ?
                                (<ActivityDiv>
                                    {posts.map((item) => (
                                        <PostComp key={uuid()} item={item} />
                                        // <Post >
                                        //     <div className={styles.postAuthorDetails}>
                                        //         <div className={styles.authorImgDiv}>
                                        //             <img src={`/profile_pics/${item.author.profile_pic}`} alt="profile"/>
                                        //         </div>
                                        //         <div className={styles.authorDets}>
                                        //             <div>{item.author.name}</div>
                                        //             <div>{getDate(item.createdAt) }</div>
                                        //         </div>
                                        //     </div>
                                        //     <div className={styles.title}>{item.title}</div>
                                        //     <div onClick={() => history.push(`/posts/${item._id}`)} className={styles.postSub}>
                                        //         <div>
                                        //             {item.body?.slice(0, 210)}
                                        //         </div>
                                        //         <div className={styles.postImgDiv}>
                                        //             <img className={styles.postImg} src={`/profile_pics/${item.image}`} alt="post"/>
                                        //         </div>
                                        //     </div>
                                        //     <div className={styles.postStats}>
                                        //         <div className={styles.stats1}>
                                        //         <ThumbUpAltOutlinedIcon  className={styles.icons}/>
                                        //             <p>{ item.likes}</p>
                                        //             <CommentOutlinedIcon className={styles.icons} />
                                        //             <p>{item.comments}</p>
                                        //         </div>
                                        //         <div>
                                        //             <BookmarkBorderOutlinedIcon onClick={() => addBookmark(item._id)} className={styles.icons} fontSize="large"/>
                                        //         </div>
                                        //     </div>
                                        // </Post>
                                    ))}
                                </ActivityDiv>) : following ? (
                                    <Following>
                                        {followingList?.map((item) => (
                                            <ProfileSmallComp key={uuid()} item={item} />
                                            // <ProfileSmall style={{cursor:"pointer"}} onClick={() => {window.location.href=`/users/${item.username}`}}>
                                            //     <ProfilePicDiv>
                                            //         <img src={`/profile_pics/${item.profile_pic}`} alt="profile"/>
                                            //     </ProfilePicDiv>
                                            //     <div className={styles.listName}>{item.name}</div>
                                            //     <div>{item.tagline}</div>
                                            //     <button className={styles.btn}>Follow</button>
                                            // </ProfileSmall>
                                        ))}
                                    </Following>
                                ) : followers ? (
                                    <Followers>
                                        {followersList?.map((item) => (
                                            <ProfileSmallComp key={uuid()} item={item} />
                                            // <ProfileSmall style={{cursor:"pointer"}} onClick={() => {window.location.href=`/users/${item.username}`}}>
                                            //     <ProfilePicDiv>
                                            //         <img src={`/profile_pics/${item.profile_pic}`} alt="profile"/>
                                            //     </ProfilePicDiv>
                                            //     <div className={styles.listName}>{item.name}</div>
                                            //     <div></div>
                                            //     <button className={styles.btn}>Follow</button>
                                            // </ProfileSmall>
                                        ))}
                                    </Followers>
                                ) : null
                            }
                        </SubDiv>
                    </Container>
                    <div style={{ minWidth: "15px" }}></div>
                </div>)} :
            </div>
    )
}